import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as common from '../../../../../common'

const DOC = gql`
  ${common.gql.dms.models.fragments.attribute.DOC}
  query GlAttributes(
    $appId: ID!
    $scenarioId: ID!
    $tenantId: ID!
    $zoneId: ID!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              rate {
                glAttributes {
                  ...FragmentDmsAttribute
                }
              }
            }
          }
        }
      }
    }
  }
`
// TODO: Check which type to use in inner transformer
// TODO: Finish transforming valueInfo
// The error I have right now is that type is {} | { type: graphql.schema.ValueType } see how to fix
const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.GlAttributesQuery,
    ents.core.common.Attribute[],
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'app',
        graphql.transformers.OUT.select(
          'scenario',
          graphql.transformers.OUT.select(
            'extra',
            graphql.transformers.OUT.select(
              'rate',
              graphql.transformers.OUT.select(
                'glAttributes',
                graphql.transformers.OUT.list(
                  graphql.transformers.OUT.pipe(
                    common.gql.dms.models.fragments.attribute.TRANSFORMER,
                    graphql.transformers.OUT.custom(
                      attribute =>
                        attribute &&
                        ents.core.dms.models.Attribute.toCommonAttribute(
                          attribute,
                        ),
                    ),
                  ),
                  { onNullish: 'remove' },
                ),
              ),
            ),
          ),
        ),
      ),
    ),
  ),
  [],
)

export const executor = graphql.createExecutor<
  graphql.schema.GlAttributesQuery,
  ents.core.common.Attribute[],
  graphql.schema.GlAttributesQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
